import { useEffect, useState } from 'react'

const TICK_MS = 1000

type UseNowTickerParams = {
  /** When false, the ticker is not scheduled and `now` is frozen. */
  isTicking: boolean
}

/**
 * 1 Hz ticker that returns the current `Date.now()`, gated by `isTicking`.
 * Shared by the single- and multi-queue-item phase-progress popovers so their
 * per-row active-phase timers and overall clocks stay in visual sync and cost
 * one interval per subscription.
 */
export function useNowTicker({ isTicking }: UseNowTickerParams): number {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    if (!isTicking) return
    const id = window.setInterval(() => setNow(Date.now()), TICK_MS)
    return () => window.clearInterval(id)
  }, [isTicking])

  return now
}
